import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { getDestination, getIcon, renderContent, renderTitle } from "components/commons/NotificationRender"
import UserImage from "components/commons/UserImage"
import formatDate from "utility/FormatDateHour"
import FormatDate from "utility/FormatDateHour"
import SystemAvatarMini from "components/commons/SystemAvatarMini"

export default function NotificationCard({
    notification,
    onNotificationArchived = () => { },
    onNotificationRead = () => { }
}) {

    const [t] = useTranslation(["global", "absenceReport", "whistle"])
    const dateString = new Date(notification.timestamp).toLocaleDateString() == new Date().toLocaleDateString() ? t("time.today") : new Date(notification.timestamp).toLocaleDateString()


    const handleNotificationRead =()=>{
        if(!notification.isRead){
            onNotificationRead(notification.guid)
        }
    }

    return (
        <div className={`card bg-dark mb-4 ${notification.isArchived && "bg-opacity-25"}`} onClick={() => { console.log("Card clicked!") }}>
            <div className="card-header row">
                <div className="col text-start">
                    <small className="text-muted">
                        {FormatDate(notification.timestamp)}
                    </small>
                </div>
                <div className="col text-end">
                    {
                        !notification.isArchived &&
                        <button className="btn btn-close bg-light" onClick={() => onNotificationArchived(notification.guid)}></button>
                    }
                </div>
            </div>
            <Link to={getDestination(notification)} state={{ guid: notification.customData?.objectGuid}} style={{ textDecoration: 'none', color: 'var(--bs-body-color)' }} onClick={handleNotificationRead}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-auto "><div className={`h-100 rounded-pill ${notification.isRead ? "bg-black bg-opacity-25" : "bg-danger"}`} style={{ width: 5 }}></div></div>
                        <div className="col-auto">
                            {
                                notification.customData?.agentGuid && notification.customData.agentGuid !== "0" ? 
                                <UserImage guid={notification.customData.agentGuid}/> : <img className="rounded-circle p-1 me-2 " width="64px" src={`/eh_pattern.png`}/>
                            }
                               
                            
                        </div>
                        <div className="col">
                            <h5 className="card-title">{getIcon(notification)}  {notification.title}</h5>
                            <p className="card-text">{notification.body}</p>
                        </div>
                  

                    </div>
                </div>
            </Link>
        </div >
    )
}